import { atomWithStorage } from 'jotai/utils';

import type { ThemeMode } from '@creditornot/cb-ingredients';

export const themeModeAtom = atomWithStorage<ThemeMode>('themeMode', 'light');
